



















export default
  name: 'ios_prompt'
  data: ->
    visible: @needsToSeePrompt()
  methods:
    hide: ->
      @visible = false
      localStorage.setItem('last_seen_ios_prompt', hm_date.constants.today)
    needsToSeePrompt: ->
      return false if HM.is_demo
      return false if navigator.standalone
      return false unless HM.is_apple
      last_seen_prompt = localStorage.getItem('last_seen_ios_prompt') || '2019-01-01'
      days_since_last_prompt = hm_date.differenceInDays(hm_date.constants.today, last_seen_prompt)
      return days_since_last_prompt > 14
